import { FlowDefinition } from "../../../core/flows/FlowDefinition";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { SettingsInitStepDeclaration } from "./Steps/SettingsInitStep";

const settingsMainStartupFlow = new FlowDefinition("SettingsFlow");

settingsMainStartupFlow.addStep(SettingsInitStepDeclaration);

settingsMainStartupFlow.setStartStep("SettingsInit_Step");

export const settingsStartupFlowDefinition = new StepDefinition({
    stepName: "SettingsFlow",
    stepFlow: settingsMainStartupFlow,
    contextIsolation: false
})